module.exports = __webpack_public_path__ + "img/340.8eb9fd56.jpg";